/**
 * Globals required by the imported cart components (cart.js, cart-drawer.js)
 * on theme pages that don't load the demo's script.js. Loaded after
 * constants.js and pubsub.js, before cart.js and cart-drawer.js.
 */
window.fetchConfig =
  window.fetchConfig ||
  function (type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
    };
  };

window.cartStrings = window.cartStrings || {
  error: "There was an error while updating your cart. Please try again.",
  quantityError: "You can only add [quantity] of this item to your cart."
};

if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.validateQtyRules();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.quantityUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.quantityUpdate,
          this.validateQtyRules.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
    }

    onInputChange() {
      this.validateQtyRules();
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      if (event.target.name === 'plus') {
        if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
          this.input.value = this.input.dataset.min;
        } else {
          this.input.stepUp();
        }
      } else {
        this.input.stepDown();
      }
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
        this.input.value = parseInt(this.input.min);
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const minusButton = this.querySelector(".quantity__button[name='minus']");
        if (minusButton) minusButton.classList.toggle('disabled', value <= parseInt(this.input.min));
      }
      if (this.input.max) {
        const plusButton = this.querySelector(".quantity__button[name='plus']");
        if (plusButton) plusButton.classList.toggle('disabled', value >= parseInt(this.input.max));
      }
    }
  }
  customElements.define('quantity-input', QuantityInput);
}
